import getCurrencyCodeFromLocale from '@/logic/getCurrencyCodeFromLocale'

const getFormattedPrice = (amount: number, locale: string) => {
    const currency = getCurrencyCodeFromLocale(locale)
    const formattedLocale = locale === 'fr-FR-CSE' ? 'fr_FR' : locale
    const currencyFormatter = new Intl.NumberFormat(
        formattedLocale.replace('_', '-'),
        {
            style: 'currency',
            currency,
        }
    )
    return currencyFormatter.format(amount)
}

export default getFormattedPrice
